module.exports = __webpack_public_path__ + "img/1F1E7-1F1F7.b8cb49d3.svg";